<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomSelect label="Тип документа" type="number" :allowNegative="true" :options="projectDocTypes"
          optionValueKey="project_document_type_id" optionLabelKey="project_document_type_name"
          :value="this.formData.project_document_type_id || ''"
          @change="(value) => onChange('project_document_type_id', value)" />
      </div>

      <DocumentUploader ref="documentUploader" :allowed-extensions="['.pdf']" accepted-formats="PDF"
        @file-selected="handleFileSelected" @file-removed="handleFileRemoved" @file-error="handleFileError" />

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomDate from "@/components/form/CustomDate";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import DocumentUploader from "@/components/common/DocumentUploader";
import { getProjectDocTypes } from "@/views/ProjectsEntry/services";

export default {
  name: "add-document-entry",
  components: { CustomDate, CustomModalFooter, CustomInput, CustomSelect, DocumentUploader },
  props: ['data'],
  data() {
    return {
      loading: false,
      fileError: '',
      formData: {
        project_document_id: this.data?.data?.project_document_id || '',
        project_document_type_id: this.data?.data?.project_document_type_id || '',
        document_file: null,
      },
      projectDocTypes: [],
    }
  },
  async mounted() {
    await this.getProjectDocTypes();
  },
  methods: {
    async getProjectDocTypes() {
      const res = await getProjectDocTypes();
      this.projectDocTypes = res || [];
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    handleFileSelected(file) {
      this.formData.document_file = file
      this.fileError = ''
    },
    handleFileRemoved() {
      this.formData.document_file = null
      this.fileError = ''
    },
    handleFileError(error) {
      this.fileError = error
    },
    async onSubmit() {
      if (!this.formData.project_document_type_id) {
        if (this.$refs.documentUploader) {
          this.$refs.documentUploader.setError('Выберите тип документа')
        } else {
          this.fileError = 'Выберите тип документа'
        }
        return
      }

      if (!this.formData.document_file) {
        if (this.$refs.documentUploader) {
          this.$refs.documentUploader.setError('Загрузите файл документа')
        } else {
          this.fileError = 'Загрузите файл документа'
        }
        return
      }

      const filteredFormData = {
        project_document_type_id: this.formData.project_document_type_id,
        document_file: this.formData.document_file,
      }

      if (this.formData.project_document_id) {
        filteredFormData.project_document_id = this.formData.project_document_id
      }

      this.loading = true
      await this.data?.onSubmit(filteredFormData)
      this.loading = false
    }
  },
  setup() {
    const { closeModal } = useAppStore()
    const { showSucceedSnackbar } = useCustomSnackbar()
    return { showSucceedSnackbar, closeModal }
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;
  margin-top: 10px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
